// src/stone/icons/MoneyHand2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MoneyHand2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M.667 7.333h38.666v20.334h-2V9.333H2.667V24h11.666v2H.667z" }),
      /* @__PURE__ */ jsx("path", { d: "M25.667 20a7.667 7.667 0 0 1 7.666-7.667h1v13.5c0 7.456-6.044 13.5-13.5 13.5-7.455 0-13.5-6.044-13.5-13.5V24h2v1.833c0 6.351 5.15 11.5 11.5 11.5 6.352 0 11.5-5.149 11.5-11.5V14.421A5.67 5.67 0 0 0 27.668 20v4.333h-1A5.667 5.667 0 0 0 21 30v1h-2v-1a7.67 7.67 0 0 1 6.667-7.602z" }),
      /* @__PURE__ */ jsx("path", { d: "M20 16a.667.667 0 1 0 0 1.333A.667.667 0 0 0 20 16m-2.666.667a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.334 0" }),
      /* @__PURE__ */ jsx("path", { d: "M20 18.333A1.667 1.667 0 1 0 20 15a1.667 1.667 0 0 0 0 3.333M7.334 6.667a6 6 0 0 1 6-6h13.333a6 6 0 0 1 6 6v2.666h-2V6.667a4 4 0 0 0-4-4H13.334a4 4 0 0 0-4 4v2.666h-2z" })
    ]
  }
);
var MoneyHand2X_default = MoneyHand2X;

export {
  MoneyHand2X,
  MoneyHand2X_default
};
